export enum TokenType{
    Totp = 'TOTP',
    Time = 'TokenTime'
}
